(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.RetireUpReturn",
            {
                url: "/RetireUpReturn",
                component: "retireUpReturn",
            });
    }]);

    app.component("retireUpReturn",
        {
            templateUrl: "/App/Transaction/RetireUpReturn/template.html",
            controller: retireUpReturnController,
            bindings: {
            }
        });

    retireUpReturnController.$inject = [
        "$state", "$scope", "transactionApi", "$q", "$location", "_", "retireUpApi", "arcEnrollments", "arcEnrollmentsApi"
    ];

    function retireUpReturnController($state, $scope, transactionApi, $q, $location, _, retireUpApi, arcEnrollments, arcEnrollmentsApi) {
        var $ctrl = this;

        /*arcEnrollments.then(function (e) {
             arcEnrollmentsApi.isEnrolled(e.retireUpId).then(function (response) {
                 $ctrl.RetireUpIsEnrolled = response;
             });
        });*/

        ng.extend($ctrl,
            {
                UI: { loading: true },
                goToProductShelf: goToProductShelf,
                goToDocumentUpload: goToDocumentUpload,
                activateRetireUpSso: activateRetireUpSso

            });

        function goToProductShelf() {
            $state.go("Transaction.Determine.ProductShelf", { transactionId: $ctrl.transaction.Id });;
        };

        function goToDocumentUpload() {
            $state.go("Transaction.Determine.Documents", { transactionId: $ctrl.transaction.Id });
        };

        function getRetireUpResponse(transactionId) {
            return transactionApi.getTransactionRetireUpResponse(transactionId);
        }

        function activateRetireUpSso() {
            //if ($ctrl.RetireUpIsEnrolled) {
                var w = window;
                w.document.write("Loading...");
                retireUpApi.initiateRetireUpSso($ctrl.transaction.Id).then(function (data) {
                    console.log(data)
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                }, function (error) {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                });
            //}
        }

        this.$onInit = function() {
            var externalIdentifier = $location.search().Id;

            if (externalIdentifier) {

                $ctrl.transaction = {};
                $ctrl.responseCusips = [];

                transactionApi.getTransactionFromExternalIdentifier(externalIdentifier).then(function (transactionIds) {
                    if (transactionIds) {
                        transactionApi.get(transactionIds.TransactionId).then(function (data) {
                            $ctrl.transaction = data;
                            $scope.$parent.$ctrl.getCurrentStage($state);
                            $ctrl.UI.HasRetireUp = $ctrl.transaction.DeterminePoints.includes("RetireUP");

                            getRetireUpResponse($ctrl.transaction.Id).then(function (data) {
                                try {
                                    var ruJsonData = JSON.parse(data.JsonData);
                                    _.find(ruJsonData,
                                        function (vSetRow) {
                                            if (vSetRow.accounts.annuity.length) {
                                                if (vSetRow.accounts.annuity[0].product.cusip !== null) {
                                                    var cusip = vSetRow.accounts.annuity[0].product.cusip.toUpperCase();
                                                    $ctrl.responseCusips.push(cusip);
                                                }
                                            }
                                        });
                                } catch (e) {
                                    console.log("Error parsing RetireUP Json data");
                                }
                            }).catch(function (e) {

                            }).then(function () {
                                if ($ctrl.responseCusips.length) {
                                    if ($ctrl.responseCusips[0].length > 0) {
                                        goToProductShelf();
                                    }
                                }

                                $ctrl.UI.loading = false;
                            });
                        });
                    }

                    else $state.go("Home.ViewTransactions");
                });
            }

            else $state.go("Home.ViewTransactions");
        };
    }
})(window.app, window.angular);